module.exports = __webpack_public_path__ + "media/images/member-database-5-c2ab57b65a08f9e1e0382bb42e3e1ba2.png";